/* eslint-disable react/prop-types */
import * as React from 'react'
import { formatters } from 'utils'
import ArticleGroupComponent from './ArticleGroup'

const ArticleGroup = ({ items: itemsProp, customItems, ...other }) => {
  const items =
    (customItems?.length > 0 && customItems.map((item) => formatters.formatCustomArticle(item))) ||
    (itemsProp?.length > 0 && itemsProp.map((item) => formatters.formatArticle(item))) ||
    []

  return <ArticleGroupComponent items={items} {...other} />
}

export default ArticleGroup
